import React, { useEffect } from "react"

const SoundCloudProvider = ({ children }) => {
  useEffect(() => {
    // Only load the script if it hasn't been loaded yet
    if (!window.SC) {
      const script = document.createElement("script")
      script.src = "https://w.soundcloud.com/player/api.js"
      script.async = true
      document.body.appendChild(script)
    }
  }, [])

  return children
}

export default SoundCloudProvider
